<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">
        <div class="form-group row justify-content-center">
          <app-input [label]="'buyer'" type="email" [formControl]="form_buyer" [size]="12"
            [autocompletionType]="autoCompletionType" [autocompletionQP]="USER_ROLES_ALLOWED"
            [autocompletionHideNoResult]="true" [hasDeleteBtn]="false" displayType="email"></app-input>
          <app-input [label]="'coBuyer'" type="email" [formControl]="form_coBuyer" [size]="12"
            [autocompletionType]="autoCompletionType" [autocompletionQP]="USER_ROLES_ALLOWED"
            [autocompletionHideNoResult]="true" [hasDeleteBtn]="false" displayType="email"></app-input>
        </div>
      </form>
    </div>
    <div class="alert-container">
      <div class="alert alert-warning" role="alert">
        Les partages existants seront supprimés, exceptés ceux des acteurs de la vente.
      </div>
    </div>
  </div>
</ng-template>